import { SURVIVOR_BALANCE } from '../config/survivorBalance';

/**
 * XP required to advance FROM `level` to the next.
 * Reads xpBase and xpPerLevel from SURVIVOR_BALANCE at call-time so live
 * Tweakpane edits propagate without a reload.
 * Default curve: 5 + 4·level.
 */
export function xpToNextLevel(level: number): number {
  return SURVIVOR_BALANCE.xpBase + SURVIVOR_BALANCE.xpPerLevel * level;
}

export type XpProgress = { level: number; xp: number };

/**
 * Add `amount` XP to a progress, rolling over as many levels as the curve allows.
 * Returns the new level, the XP into the (new) current level, and how many levels
 * were gained. `level` starts at 1.
 */
export function addXp(p: XpProgress, amount: number): { level: number; xp: number; levelsGained: number } {
  let level = p.level;
  let xp = p.xp + amount;
  let levelsGained = 0;
  let need = xpToNextLevel(level);
  while (xp >= need) {
    xp -= need;
    level += 1;
    levelsGained += 1;
    need = xpToNextLevel(level);
  }
  return { level, xp, levelsGained };
}
